// extracted by mini-css-extract-plugin
export default {"user__detailsItem":"UserOrderDetailsItem_user__detailsItem__UmrFf","user__detailsLink":"UserOrderDetailsItem_user__detailsLink__RJTLE"};